module.exports = __webpack_public_path__ + "assets/img/tag_list-73ac8f14.png";